/*
Author: Shivakumar
Date: 31/03//2020
Description : [Run Pay Roll Summary Page] Summary Page Getting Cancelled.
search_string: PL_2957
*/
<template>
  <div class="margin-bottom-100">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <!-- <div class="row margintop-32">
        <div>
          <tl-radio
            name="paygroup"
            label="Paygroups"
            id="paygroup"
            value="paygroup"
            v-model="selectMethod"
            @change="(val) => setPaygroup(val)"
          />
        </div>
        <div class="col-3">
          <tl-radio
            name="selectEmp"
            label="Select Employees"
            id="selectEmp"
            value="selectEmp"
            v-model="selectMethod"
            @change="(val) => setPaygroup(val)"
          />
        </div>  
    </div> -->

    <div>
      <div class="paygrpsDiv">
        <div class="paygrp" @click="changeClassFunc">
          <span>Paygroups Selected</span>
          <div class="paygrps-info">
            <b>{{ countObj.payGroupsSelected }}</b>
            / {{ paygroupsData.length }}
          </div>
        </div>
        <div class="alignPaygrp">
          <span>Total Employees</span>
          <br />
          <div class="paygrps-info">
            <b>{{ countObj.employeesSelected }}</b>
            / {{ countObj.totalEmployees }}
          </div>
        </div>
        <div class="alignPaygrp">
          <span>Eligible Employees</span>
          <br />
              <div class="paygrps-info">
                <b>{{ countObj.eligibleEmployees }}</b>
                / {{ countObj.totalEmployees }}
              </div>
            </div>
            <div class="alignPaygrp">
              <span>Ineligible Employees</span>
              <br />
              <div class="paygrps-info">
                <b>{{ countObj.inEligibleEmployees }}</b>
                / {{ countObj.totalEmployees }}
              </div>
            </div>
          </div>
          <div class="d-payroll__group">
            <div class="d-heading2 d-marginBottom d-flexbox">
              Select Paygroups
              <div class="groupSelect">
                Select:
                <span class="groupSelect-tab" @click="selectAll">All</span>
                <span class="groupSelect-tab" @click="deSelectAll">None</span>
              </div>
            </div>
          </div>

          <div v-for="(item, index) in paygroupsData" :key="index">
            <div class="groupBlockExpanded d-pending-lighten" :class="{ width_100: item.isExpanded }">
              <input
                type="checkbox"
                class="groupInput"
                name="check"
                @click="payGroupSelection(index)"
                :checked="item.isExpanded"
              />
              <span class="checkInput"></span>
              <div class="paygrpName">
                <div class="width_120">
                  <p>
                    {{ item.payGroupName }}
                    <span class="d-pending-lighten">Pending</span>
                  </p>
                </div>
                <span :class="{ 'vertical-line': item.isExpanded }" />
                <div :class="{ isHidden: !item.isExpanded }">
                  <p>
                    Total Employees
                    <span class="paygrps-info-data">
                      <b>{{ item.totalEmployess }}</b>
                    </span>
                  </p>
                </div>
                <p :class="{ isHidden: !item.isExpanded }">
                  New Joiners
                  <span class="paygrps-info-data">
                    <b>{{ item.newJoineese }}</b>
                  </span>
                </p>
                <p :class="{ isHidden: !item.isExpanded }">
                  Resignees
                  <span class="paygrps-info-data">
                    <b>{{ item.resignees }}</b>
                  </span>
                </p>
                <p :class="{ isHidden: !item.isExpanded }">
                  Eligible Employees
                  <span class="paygrps-info-data">
                    <b>{{ item.eligibleEmployees }}</b>
                  </span>
                </p>
                <p :class="{ isHidden: !item.isExpanded }">
                  Ineligible Employees
                  <span class="paygrps-info-data">
                    <b>{{ item.ineligilityEmployees }}</b>
                  </span>
                </p>
              </div>
            </div>
          </div>
      </div>

      <div>
        <div class="margintop-32">
          <h4 class="employeeTitle">Select Employees</h4>
          <textarea class="form-control custom-textarea margintop-16" rows="15"  name="selectEmp" v-model="details"
            placeholder="Enter employee codes seperated by comma ( , )"/>
        </div>
      </div>

    <footer>
      <bottom-action-container>
        <template slot="end">
          <btn-grp class="form-button">
            <btn text="Next" type="primary" @click="save" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "Paygroups",
  data() {
    return {
      details:"",
      selectMethod: "paygroup",
      errmsg: "",
      toast: false,
      changeClass: false,
      countObj: {
        payGroupsSelected: 0,
        employeesSelected: 0,
        eligibleEmployees: 0,
        inEligibleEmployees: 0,

        totalEmployees: 0,
        totalEligibleEmployees: 0,
        totalInEligibleEmployees: 0
      },
      paygroupsData: []
    };
  },

  activated() {
    this.refresh();
    this.fetchAll();
  },

  mounted() {},

  beforeDestroy() {
    this.refresh();
  },

  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      selectedPayGroupsData: state => state.payroll.paygroups.data,
      selectedEmployeesData: state => state.payroll.paygroups.employeeData,
      isSelected: state => state.payroll.paygroups.isSelectedEmployees,
      totalPayGroupsData: state => state.payroll.paygroups.payGroups,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),

    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else {
        return this.getleid(0);
      }
    }
  },

  methods: {
    ...mapActions({
      act_fetchAll: "payroll/paygroups/fetchAll",
      act_create: "payroll/paygroups/create",
      act_create_selected_employees: "payroll/paygroups/selectEmployees",
    }),

    /** Function to fetch all the paygroups of this LE */
    async fetchAll() {
      try {
        //PL_2957
        let res = await this.act_fetchAll({
          le_id: this.le_id,
          processing_payroll_month: this.getSelectedMonthEnumByName(
            this.payrollMonth
          ),
          financial_year: this.payrollYear
        });
        // PL_2957
        if (res.status) {
          let dataArr = res.data.payload.data;
          // Logic to show the count on UI 
          this.countObj.totalEmployees = 0;
          this.countObj.totalEligibleEmployees = 0;
          this.countObj.totalInEligibleEmployees = 0;

          dataArr.forEach(data => {
            data.isExpanded = false;
            this.countObj.totalEmployees =
              this.countObj.totalEmployees + data.totalEmployess;
            this.countObj.totalEligibleEmployees =
              this.countObj.totalEligibleEmployees + data.eligibleEmployees;
            this.countObj.totalInEligibleEmployees =
              this.countObj.totalInEligibleEmployees +
              data.ineligilityEmployees;
          });
          this.paygroupsData = dataArr;
          this.setData();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    // async setPaygroup(val){
    //   if(val == "paygroup"){
    //     let obj = {
    //       data: [],
    //       le_id: this.le_id,
    //       isSelectedEmployee: true
    //     }
    //     let res = await this.act_create_selected_employees(obj);
    //   }else{
    //     let obj = {
    //       data: [],
    //       le_id: this.le_id,
    //       payrollMonth: this.payrollMonth,
    //       payrollYear: this.payrollYear,
    //       isSelectedEmployee: false
    //     };
    //     let res = await this.act_create(obj);
    //   }
    // },
    /** To auto select the checkboxes for the already selected paygroups in UI */
    setData() {
      try {
        let details = this.selectedEmployeesData[this.le_id];
        this.details = details && details.toString();
        let selectedPayGroupsData = this.selectedPayGroupsData[this.le_id];
        if (selectedPayGroupsData) {
          if (this.paygroupsData.length) {
            this.paygroupsData.forEach(item => {
              let selectedPayGroupIndex = selectedPayGroupsData.findIndex(
                ele => ele.id == item.id
              );
              if (selectedPayGroupIndex > -1) {
                item.isExpanded = true;
                this.updateCountValues(item);
              }
            });
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },


    changeClassFunc() {
      this.changeClass = true;
    },
    /** On Checkbox click of paygroup */
    payGroupSelection(index) {
      try {
        this.paygroupsData[index].isExpanded = !this.paygroupsData[index]
          .isExpanded;
        let payGroupObj = this.paygroupsData[index];
        this.updateCountValues(payGroupObj);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On Checkbox click of 'Select All' Paygroups */
    selectAll() {
      try {
        this.paygroupsData.forEach(data => {
          data.isExpanded = true;
        });
        this.paygroupsData = [...this.paygroupsData];
        this.updateHeadersCount();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On Checkbox click of 'None' Paygroups */
    deSelectAll() {
      try {
        this.paygroupsData.forEach(data => {
          data.isExpanded = false;
        });
        this.paygroupsData = [...this.paygroupsData];
        this.resetHeadersCount();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to show the updated count in UI on select/deselect of paygroups selection */
    updateHeadersCount() {
      try {
        this.resetHeadersCount();
        if (this.paygroupsData.length) {
          this.paygroupsData.forEach(data => {
            this.updateCountValues(data);
          });
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to reset the count data  */
    resetHeadersCount() {
      try {
        this.countObj.payGroupsSelected = 0;
        this.countObj.employeesSelected = 0;
        this.countObj.eligibleEmployees = 0;
        this.countObj.inEligibleEmployees = 0;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to append the count values to show in UI as received from server */
    updateCountValues(data) {
      try {
        if (data.isExpanded) {
          this.countObj.payGroupsSelected = this.countObj.payGroupsSelected + 1;
          this.countObj.employeesSelected =
            this.countObj.employeesSelected + data.totalEmployess;
          this.countObj.eligibleEmployees =
            this.countObj.eligibleEmployees + data.eligibleEmployees;
          this.countObj.inEligibleEmployees =
            this.countObj.inEligibleEmployees + data.ineligilityEmployees;
        } else {
          this.countObj.payGroupsSelected = this.countObj.payGroupsSelected - 1;
          this.countObj.employeesSelected =
            this.countObj.employeesSelected - data.totalEmployess;
          this.countObj.eligibleEmployees =
            this.countObj.eligibleEmployees - data.eligibleEmployees;
          this.countObj.inEligibleEmployees =
            this.countObj.inEligibleEmployees - data.ineligilityEmployees;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to save the selected data into the store */
    async save() {
        try {
        this.toast = false;
        this.errmsg = "";

        let selectedPaygroups = [];
        this.paygroupsData.forEach(data => {
          if (data.isExpanded) {
            selectedPaygroups.push(data);
          }
        });

        if (!selectedPaygroups.length) {
          this.toast = true;
          this.errmsg = "Please select atleast one pay group";
          return;
        }

        let obj = {
          data: selectedPaygroups,
          le_id: this.le_id,
          payrollMonth: this.payrollMonth,
          payrollYear: this.payrollYear,
        };

        try {
          this.$root._data.isSaving = true;
          let res = await this.act_create(obj);
          setTimeout(() => {
            if (res.status == 200) {
              this.$router.push({
                path: `/payroll/run/${this.$route.params.entity_index}/joinings`
              });
              this.refresh();
            }
            this.$root._data.isSaving = false;
          }, 500);
        } catch (err) {
          this.$root._data.isSaving = false;
          this.toast = true;
          this.errmsg = err;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
        let value = this.details.split(",");
        let value2 = [];
        value.map(element => {
          if(element){
            value2.push(element.trim());
          }
        })
        let filter = value2.filter(element => element !== "")
        let obj = {
          data: filter,
          le_id: this.le_id,
        }
        try {
          this.$root._data.isSaving = true;
          let res = await this.act_create_selected_employees(obj);
          setTimeout(() => {
            if (res.status == 200) {
              this.$router.push({
                path: `/payroll/run/${this.$route.params.entity_index}/joinings`
              });
              this.refresh();
            }
            this.$root._data.isSaving = false;
          }, 500);
        } catch (err) {
          this.$root._data.isSaving = false;
          this.toast = true;
          this.errmsg = err;
        }
    },
    /** To reset the UI elements data */
    refresh() {
      try {
        this.toast = false;
        this.errmsg = "";
        this.paygroupsData = [];
        this.details = "";
        this.countObj = {
          payGroupsSelected: 0,
          employeesSelected: 0,
          eligibleEmployees: 0,
          inEligibleEmployees: 0,

          totalEmployees: 0,
          totalEligibleEmployees: 0,
          totalInEligibleEmployees: 0
        };
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** FUnction to return the selected month enum */
    getSelectedMonthEnumByName(selectedMonth) {
      try {
        let selectedMonthEnum = "";
        switch (selectedMonth) {
          case "January":
            selectedMonthEnum = "jan";
            break;
          case "February":
            selectedMonthEnum = "feb";
            break;
          case "March":
            selectedMonthEnum = "mar";
            break;
          case "April":
            selectedMonthEnum = "apr";
            break;
          case "May":
            selectedMonthEnum = "may";
            break;
          case "June":
            selectedMonthEnum = "jun";
            break;
          case "July":
            selectedMonthEnum = "jul";
            break;
          case "August":
            selectedMonthEnum = "aug";
            break;
          case "September":
            selectedMonthEnum = "sep";
            break;
          case "October":
            selectedMonthEnum = "oct";
            break;
          case "November":
            selectedMonthEnum = "nov";
            break;
          case "December":
            selectedMonthEnum = "dec"; // PL-2264
            break;

          default:
            break;
        }
        return selectedMonthEnum; // Enum type - values :  ['jan', 'feb','mar', 'apr','may', 'jun','jul', 'aug','sep', 'oct','nov', 'dec']
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section

.margin-bottom-100 {
  margin-bottom: 100px;
}
.paygrpsDiv {
  display: flex;
  cursor: pointer;
  padding: 40px 0px;
  span {
    color: #646464;
    font-size: 16px;
  }
  > :nth-child(n) {
    margin-right: 64px;
  }
  > :last-child {
    margin-right: 0px;
  }
}
.paygrps-info {
  color: #646464;
  cursor: pointer;
  text-align: center;
  margin-top: 5px;
  b {
    font-size: 24px;
    font-weight: 500;
  }
}
.paygrp {
  background: #fbfbfb;
  width: 220px;
  height: 85px;
  border-radius: 2px;
  border: solid 1px #37c6c0;
  padding: 20px;
  text-align: center;
}
.alignPaygrp {
  padding: 20px;
  text-align: center;
}
.d-marginBottom {
  margin-bottom: 16px;
}
.line {
  border-bottom: 1px solid #c8c8c8;
  width: 100%;
  margin-bottom: 20px;
}
.paygrps-list {
  display: flex;
}
.paygrp-one {
  width: 205px;
  height: 69px;
  border-radius: 4px;
  border: solid 1px #f0f0f0;
  background-color: #fbfbfb;
}
.groupBlock {
  width: 17%;
  margin-right: 2%;
}
.vertical-line {
  width: 2px;
  height: 59px;
  border: solid 1px #f0f0f0;
}
.isHidden {
  display: none;
}
.groupInput {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  margin: auto;
  opacity: 0;
  z-index: 1;
  cursor: pointer;
  &:checked + .checkInput {
    background: $d-checkbox-color;
  }
}
.checkInput {
  position: absolute;
  width: 14px;
  height: 14px;
  top: 0;
  bottom: 0;
  margin: auto;
  left: 10px;
  border-radius: 2px;
  border: solid 1px #bebebe;
  background: #f9f9f9;
  &:before {
    content: "";
    position: absolute;
    top: 3px;
    left: 2px;
    width: 8px;
    height: 4px;
    border-left: solid thin #ffffff;
    border-bottom: solid thin #ffffff;
    transform: rotate(-45deg);
  }
}
.paygrpName {
  padding: 0 0 0 25px;
  color: #646464;
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-right: 3%;
  span {
    display: block;
    font-size: 12px;
    padding-top: 5px;
  }

  p {
    margin-bottom: 10px;
    margin-top: 10px;
  }
}

.pending {
  font-size: 12px;
  color: #ffb442;
  margin-left: 18px;
}
.groupBlockExpanded {
  margin-bottom: 20px;
  width: 19%;
  position: relative;
  border: solid 1px #f0f0f0;
  border-left: solid 10px;
  height: 65px;
  border-radius: $d-border-radius;
  padding-left: 13px;
  display: grid;
  align-items: center;
  font-size: $font-size;
  background: #fbfbfb;
}
.paygrps-info-data {
  color: #646464;
  text-align: center;
}

.width-17 {
  width: 17%;
}

.width_100 {
  width: 100%;
}

.width_120 {
  width: 120px;
}

.employeeTitle{
  color: #777777;
}

.custom-textarea {
  width: 80%;
  height: 100%;
}
</style>
